<template>
	<div class="gallery">
		<component v-if="type" :is="typeComponent" :type="type" :items="items" />
	</div>
</template>

<script>
import Type from './Types'

export default {
	props: {
		id: String,
		type: String,
		items: {
			type: [Array, Object],
		},
	},
	data() {
		return {}
	},
	computed: {
		typeComponent() {
			switch (this.type) {
				case 'single--small':
				case 'single--medium':
				case 'single--large':
				case 'cover':
					return Type.Single
				case 'side-by-side':
					return Type.SideBySide
				default:
					return Type.Single
			}
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.gallery {
}
</style>
